










































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
import Loading from '@/app/components/Common/Loading.vue'
import FieldMap from '@/app/components/Field/FieldMap.vue'
import FieldList from '@/app/components/Field/FieldList.vue'
/* api */
import FieldListApi from '@/app/model/api/fieldListApi'
import FieldSortApi from '@/app/model/api/fieldSortApi'
import FieldDetailsApi from '@/app/model/api/fieldDetailsApi'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import MapClass from '@/app/module/map'
import { routerPath, fieldDetailsApiFlag, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    Loading,
    FieldMap,
    FieldList
  }
})
export default class FieldChoiceModal extends Vue {
  private isOpend: any = {}
  /* データ */
  private accordionData: Array<{[key:string]: string}> = []
  private accordionList: Array<{[key:string]: string}> = []
  private mapList: Array<{[key:string]: any}> = []
  private fieldList: Array<{[key:string]: any}> = []
  public mapData: Array<{[key:string]: any}> = []
  private target: string = '1'
  /* 表示非表示 */
  private showListLoading: boolean = true
  private renderList: boolean = false
  private accordionChangeFlag: boolean = true
  private accordionOpenFlag: boolean = true

  /* computed */
  private get fieldChoiceState (): number {
    return this.$store.state.fieldChoiceState.modalId
  }

  @Watch('fieldChoiceState')
  onIdChange (id: string) {
    if (this.decisionPlanting(id)) {
      this.getFieldName(id)
    }
    if (id !== '' && id !== null) {
      let el: any = document.getElementById(id)

      if (el !== null && el !== undefined) {
        let acoordionId = el.parentElement.parentElement.parentElement.previousElementSibling.getAttribute('id')
        let index = acoordionId.indexOf('/')
        let id = acoordionId.slice(index + 1)

        this.openSpecificAccordion(id)
        if (el && this.$store.state.fieldChoiceState.isScroll) {
          el.scrollIntoView({ behavior: 'instant' })
        } else {
          this.$store.commit('fieldChoiceState/setIsScroll', true)
        }
      }
    }
  }
  created () {
    (async () => {
      const result = await FieldListApi.getFieldData(true, '0', {})

      if (result.isOk()) {
        this.accordionData = result.getPayload().accordion_list
        this.accordionList = result.getPayload().accordion_list

        this.mapList = Array(result.getPayload().polygon_list.length)
        this.fieldList = Array(result.getPayload().polygon_list.length)

        /* マップデータ作成 */
        for (var j in result.getPayload().polygon_list) {
          this.createDataList(result.getPayload().polygon_list[j], parseInt(j))
        }

        /* エリアごとに詳細を取得 */
        for (var k in result.getPayload().accordion_list) {
          let accordionData = result.getPayload().accordion_list[k]
          this.getFieldDetailsData(accordionData.accordion_id, true)
        }

        this.mapCreate()
        this.renderList = true
        this.showListLoading = false
        this.$store.commit('setFlagState/setFieldModalDetailsFlag', true)
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  /* ターゲットの変更 */
  private async changeTarget () {
    this.showListLoading = true
    this.renderList = false
    this.accordionData = []
    this.fieldList = []

    const searchItem = {
      accordion: this.target,
      refile: this.$store.state.fieldState.plantingOnly,
      status: 0,
      variety: '',
      risk: 0,
      word: '',
      target: this.target
    }
    const result = await FieldSortApi.doFieldSort(fieldDetailsApiFlag.FLAG_FIELD_TARGET, searchItem, [])

    if (result.isOk()) {
      /* マップのデータを作成 */
      /* マップのデータを作成 */
      if (result.getPayload().polygon_list.length !== 0) {
        this.accordionData = result.getPayload().accordion_list
        this.accordionList = result.getPayload().accordion_list

        /* アコーディオンを一度すべて閉じる */
        for (var i in this.accordionList) {
          let id = this.accordionList[i].accordion_id
          this.$set(this.isOpend, id, false)
        }

        // リセット
        this.mapList = Array(result.getPayload().polygon_list.length)
        this.fieldList = Array(result.getPayload().polygon_list.length)

        // データ取得できたら描画
        this.renderList = true

        /* エリアごとに詳細を取得 */
        for (var k in result.getPayload().accordion_list) {
          let accordionData = result.getPayload().accordion_list[k]
          this.getFieldDetailsData(accordionData.accordion_id, true)
        }

        /* マップデータ作成 */
        for (var j in result.getPayload().polygon_list) {
          this.createDataList(result.getPayload().polygon_list[j], parseInt(j))

          /* エリアデータをlocalstorageに保存 */
          let accordionData = result.getPayload().polygon_list[j]
          accordionData['timestamp'] = Date.now()
        }
      } else {
        this.accordionData = []
        this.accordionList = []

        this.mapList = []
        this.fieldList = []
      }

      this.$store.commit('setFlagState/setFieldModalDetailsFlag', true)
      this.mapCreate()
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
    }
    this.showListLoading = false
  }

  /* 詳細データ取得 */
  private getFieldDetailsData (id: number, idFlag: boolean) : any {
    (async () => {
      if (id !== 0 && id !== undefined) {
        /*
         * sessionStorageにデータがない場合、
         * もしくはアコーディオンのターゲットを変える場合はAPIを叩く
         */
        if ((Session.getModalFieldDetailsData(String(id))! === null) ||
             this.target !== Session.getChoiceModalGrouping()) {
          let searchItem = {
            accordion: this.target,
            refile: this.$store.state.fieldState.plantingOnly,
            stage: '',
            variety: '',
            risk: 0,
            word: ''
          }

          const result = await FieldDetailsApi.getFieldDetailsData(String(id), idFlag, fieldDetailsApiFlag.FLAG_FIELD, searchItem, [])
          if (result.isOk()) {
            if (result.getPayload() === null) {
              return
            }

            result.getPayload().field_detail_list.unshift({ timestamp: Date.now() })

            Session.setModalFieldDetailsData(JSON.stringify(result.getPayload().field_detail_list), String(id))
            // 保存したグルーピングの情報を保持
            Session.setChoiceModalGrouping(this.target)

            /* データ取得フラグ */
            this.$store.commit('setFlagState/setFieldModalDetailsFlag', true)

            let fieldList: any = this.$refs.fieldList
            if (fieldList !== undefined) {
              for (var i in fieldList) {
                if (fieldList[i].id === id) {
                  fieldList[i].showLoading = false
                }
              }
            }
          } else {
            const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
          }
        } else {
        /* データ取得フラグ */
          this.$store.commit('setFlagState/setFieldModalDetailsFlag', true)
        }
      }
    })()
  }

  /* 取得したデータからリストを作成 */
  private createDataList (result: any, key: number) {
    /* マップのデータを作成 */
    const mapData: any = {
      id: result.polygon_field_id,
      path: result.polygon,
      strokeColor: result.polygon_color,
      fillColor: result.polygon_frame_color,
      fieldComSensor: MapClass.getSensorLatLng('field_cam_sensor', result.field_cam_sensor),
      canonSensor: MapClass.getSensorLatLng('canon_sensor', result.canon_sensor),
      fieldServerSensor: MapClass.getSensorLatLng('field_server_sensor', result.field_server_sensor),
      paddyWatchSensor: MapClass.getSensorLatLng('paddy_watch_sensor', result.paddy_watch_sensor)
    }

    const fieldData: any = {
      fieldName: result.polygon_field_name,
      fieldId: result.polygon_field_id,
      plantingId: result.polygon_planting_id,
      accordionId: result.accordion_id
    }

    if (result.polygon.length === 0) {
      mapData.fieldPosition = {
        lat: parseFloat(result.field_lat),
        lng: parseFloat(result.field_lng)
      }
    }

    this.mapList[key] = mapData
    this.fieldList[key] = fieldData
  }

  /* ポリゴン表示 */
  private mapCreate () {
    if (this.mapList.length !== 0) {
      /* リストの一番上のデータをマップの中心にする */
      if (Session.getChoiceFieldId()! === null) {
        if (Object.keys(this.mapList[0].path).length !== 0) {
          if (this.$store.state.mapState.basicData.position.lng === this.mapList[0].path[0].lng) {
            this.$store.commit('mapState/setBaseData', this.mapList[0].path[1])
          } else {
            this.$store.commit('mapState/setBaseData', this.mapList[0].path[0])
          }
        } else {
          this.$store.commit('mapState/setBaseData', {
            lat: parseFloat(this.mapList[0].field_lat),
            lng: parseFloat(this.mapList[0].field_lng)
          })
        }
      } else {
        for (var i in this.mapList) {
          if (this.mapList[0].path.length !== 0) {
            this.$store.commit('mapState/setBaseData', this.mapList[0].path[1])
          } else {
            this.$store.commit('mapState/setBaseData', this.mapData[i].fieldPosition)
          }
        }
      }
    }

    this.$store.commit('mapState/setMapList', this.mapList)
    this.mapData = this.$store.state.mapState.mapData
  }

  private decisionPlanting (id: string) {
    let plantingId = this.$store.state.fieldChoiceState.modalPlantingId

    for (var i in this.fieldList) {
      if (id === this.fieldList[i].fieldId) {
        if (plantingId === 0) {
          return false
        } else {
          return true
        }
      }
    }
  }

  /* 圃場選択 */
  private getFieldName (id: string) {
    for (var i in this.fieldList) {
      if (this.fieldList[i].fieldId === id) {
        this.$emit('get-field-name', this.fieldList[i].fieldName)
        this.$emit('get-field-id', this.fieldList[i].fieldId)
      }
    }
  }

  /* アコーディオン */
  private isOpenedAccordion (key: number) {
    if (this.accordionChangeFlag) {
      this.accordionChangeFlag = false
    } else {
      this.accordionChangeFlag = true
    }

    this.accordionOpenFlag = false
    this.$set(this.isOpend, key, !this.isOpend[key])
  }

  private openSpecificAccordion (areaId: string) {
    if (this.accordionChangeFlag) {
      this.accordionChangeFlag = false
    } else {
      this.accordionChangeFlag = true
    }

    this.accordionOpenFlag = true
    let key = parseInt(areaId)
    this.$set(this.isOpend, key, true)
  }

  private afterTransition () {
    let id = this.$store.state.fieldChoiceState.modalId
    let el: any = document.getElementById(String(id))

    // クリックでアコーディオンを開くときはscrollしない
    if (el && this.accordionOpenFlag) {
      el.scrollIntoView({ behavior: 'instant' })
    }
    this.accordionOpenFlag = true
  }
}
